import ModalTemplate from "../../../common/modal/modalTemplate";

const styles = {
    container: {
        padding: "24px 18px 18px",
        fontFamily: "Poppins, sans-serif",
    },
    closeButton: {
        top: "14px",
        right: "14px",
        width: "36px",
        height: "36px",
        borderRadius: "50%",
        background: "#f2f2f2",
        border: "none",
        color: "#999",
        fontSize: "20px",
    },
    iconWrapper: {
        width: "90px",
        height: "90px",
        borderRadius: "50%",
        border: "4px solid #e8e8e8",
        color: "#a0a0a0",
        fontSize: "42px",
    },
    title: {
        fontSize: "30px",
        color: "#111",
        lineHeight: "1.4",
    },
    description: {
        color: "#8f8f8f",
        fontSize: "16px",
        lineHeight: "1.8",
    },
    actionButton: {
        borderRadius: "10px",
        background: "#18d96f",
        color: "#fff",
        border: "none",
        boxShadow: "0 5px 15px rgba(24, 217, 111, 0.3)",
    },
    infoBox: {
        background: "#f5f5f5",
        border: "1px solid #e4e4e4",
        borderRadius: "10px",
        color: "#9b9b9b",
        fontSize: "15px",
        gap: "10px",
        padding: "12px",
    },
};

const FtmsNotFound = ({ open, handleClose, widenArrivalWindow }) => {
    return (
        <ModalTemplate
            show={open}
            closeFun={handleClose}
            centered
            isRemoveBodyPadding={true}
            body={
                <div className="d-flex justify-content-center align-items-center bg-light">
                    <div
                        className="position-relative bg-white shadow"
                        style={styles.container}
                    >
                        {/* Close Button */}
                        <button
                            type="button"
                            onClick={handleClose}
                            className="btn position-absolute d-flex justify-content-center align-items-center"
                            style={styles.closeButton}
                        >
                            <i className="material-symbols-rounded">close</i>
                        </button>

                        {/* Icon */}
                        <div className="d-flex justify-content-center my-4">
                            <div
                                className="d-flex justify-content-center align-items-center"
                                style={styles.iconWrapper}
                            >
                                <img
                                    src="/assets/img/clock-edit.svg"
                                    alt="Clock"
                                />
                            </div>
                        </div>

                        {/* Title */}
                        <h3
                            className="text-center fw-semibold"
                            style={styles.title}
                        >
                            No engineer has accepted yet
                        </h3>

                        {/* Description */}
                        <p
                            className="text-center mt-3"
                            style={styles.description}
                        >
                            No tradesperson accepted this job for the selected
                            arrival window. This usually means the time slot is
                            too narrow.
                        </p>

                        <p
                            className="text-center mb-4"
                            style={styles.description}
                        >
                            Widening your arrival window or choosing a different
                            time increases the chance of acceptance.
                        </p>

                        {/* Action Button */}
                        <button
                            type="button"
                            className="btn w-100 fw-semibold"
                            style={styles.actionButton}
                            onClick={widenArrivalWindow}
                        >
                            Widen arrival window
                        </button>

                        {/* Bottom Info */}
                        <div
                            className="d-flex align-items-center justify-content-center mt-3"
                            style={styles.infoBox}
                        >
                            <i className="material-symbols-rounded">
                                info
                            </i>

                            <span>
                                We’ll notify you if availability changes.
                            </span>
                        </div>
                    </div>
                </div>
            }
        />
    );
};

export default FtmsNotFound;